import owd from 'owd/owd';
import 'jquery-lazy';

export default class Src extends owd.Component {
	init() {
        this.lazy = this.$element.lazy({
            effect: "fadeIn",
            effectTime: 500,
            threshold: 1500,
            chainable: false,
            visibleOnly: true
        });

		this.bind();
	}

	bind() {
        this.on('layout-reflow', this.dom.$window, () => {
            this.lazy.update();
        });
        this.on('pageOut', this.dom.$window, () => {
            
        });
    }

    destroy() {
        super.destroy();
        this.lazy.destroy();
    }
}

owd.registerComponent('src', {
	component: Src
});
